import { Link } from "react-router-dom";
import { ErthNav } from "../erth/ErthNav";
import { ErthFooter } from "../erth/ErthFooter";
import { DropHeading } from "../erth/DropHeading";
import { Reveal } from "../components/Reveal";
import { ArticleCard } from "../journal/ArticleCard";
import { ARTICLES } from "../journal/articles";
import { useSeo } from "../hooks/useSeo";
import { ORGANIZATION, breadcrumbs, graph } from "../seo/schema";

export default function JournalPage() {
  useSeo({
    title: "Journal | erth. escapes",
    description:
      "Guides to planning private villa stays, group getaways and celebrations near Bengaluru, plus the story behind erth. escapes and Dune Villas at Area 83.",
    path: "/journal",
    image: ARTICLES[0].cover,
    jsonLd: graph(
      ORGANIZATION,
      breadcrumbs([{ name: "erth. escapes", path: "/" }, { name: "Journal", path: "/journal" }]),
      {
        "@type": "CollectionPage",
        name: "Journal | erth. escapes",
        url: "__ORIGIN__/journal",
        hasPart: ARTICLES.map((a) => ({ "@type": "Article", headline: a.title, url: `__ORIGIN__/journal/${a.slug}` })),
      }
    ),
  });

  return (
    <div data-testid="journal-page" className="min-h-screen bg-erth-beige font-body">
      <ErthNav />
      <main className="pt-[4.5rem]">
        <section className="mx-auto max-w-7xl px-6 pb-20 pt-16 sm:px-8 lg:pb-32 lg:pt-24">
          <Reveal className="max-w-2xl">
            <nav aria-label="Breadcrumb" className="mb-6 font-body text-xs tracking-[0.22em] text-erth-black/50">
              <Link to="/" className="hover:opacity-60">erth. escapes</Link> / journal
            </nav>
            <DropHeading as="h1" testId="journal-heading" text="the journal" className="text-4xl leading-none text-erth-black sm:text-5xl lg:text-6xl" />
            <p className="mt-7 font-body text-lg font-light leading-relaxed text-erth-black/75 sm:text-xl">
              Practical guides to planning stays, celebrations and group weekends, and the thinking behind erth. escapes.
            </p>
          </Reveal>
          <div className="mt-14 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.08}>
                <ArticleCard a={a} index={i} />
              </Reveal>
            ))}
          </div>
        </section>
      </main>
      <ErthFooter />
    </div>
  );
}
